import AssignLessonActionWithDateSelectionV2 from '../../../../lessons/lessonactions/lesson-multi-selection-actions/AssignLessonActionWithDateSelectionV2';
import { useFetchMyLessons, useHandleTeacherCourseAssigment } from '../MyLessonsHook';
import { useGetAssignedStudentCourses } from '../../../../lessons/assigned-student-courses/AssignedStudentCoursesHooks';

import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  lessons: [],
  selectedLessonIds: [],
  selectedDates: {},
};

export default function MyLessonsAssignLessonsAction(p) {
  const { lessons, selectedLessonIds, selectedDates } = { ...defaultProps, ...filterUndefined(p) };
  const {
    fetchMyLessons,
  } = useFetchMyLessons();

  const propsArg = useHandleTeacherCourseAssigment();

  const {
    getAssignedStudentData,
  } = useGetAssignedStudentCourses({
    onStartLoading: null,
    subjectId: propsArg.subjectId,
    onDataLoad: propsArg.onDataLoad,
    assignedStudentCourses: propsArg.assignedStudentCourses,
    filterCriteriaAssignedStudentCourses: propsArg.filterCriteriaAssignedStudentCourses,
  });

  return (
    <AssignLessonActionWithDateSelectionV2
      lessons={lessons}
      selectedLessonIds={selectedLessonIds}
      showAddToMyList={false}
      reloadDataFunc={async () => {
        fetchMyLessons(false, selectedLessonIds);
        getAssignedStudentData(selectedDates);
      }}
    />
  );
}
